<template>
  <div>
    <v-row>
      <v-card>
        <v-card-title>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
            <v-data-table
                    :search="search"
                    :headers="headers"
                    :items="ser_records"
                    :items-per-page="15"
                    class="elevation-1"
            ></v-data-table>
        <v-card-actions>
          <vue-json-to-csv :json-data="ser_records" :csv-title="relay.relay_name + ' SER'">
            <v-btn>
              Download as CSV
            </v-btn>

          </vue-json-to-csv>


        </v-card-actions>
      </v-card>
    </v-row>
  </div>
</template>

<script>
  import VueJsonToCsv from 'vue-json-to-csv';
  export default {
    name: 'RelaySerTable',
    data: () => ({
      search: '',
      headers: [
        {
          text: "Time",
          value: "time"
        },
        {
          text: "Element",
          value: "element_name"
        },
        {
          text: "State",
          value: "element_state"
        }

      ],

      panel: [0,1],
      menu: false,
      meterChart: {}
    }),
    props: {
      relay: {
        type: Object,
        required: true
      },
      ser_records: {
        type: Array,
        required: true
      }
    },
    computed:{
    },
    methods:{


    },
    mounted() {
      console.log("RelaySerTable");
    },
    components:{
      VueJsonToCsv
    },

  }
</script>
